// extracted by mini-css-extract-plugin
export default {"phtv_text":"index_phtv_text_Xm-yM"};